import type React from 'react';

import { type Preview } from '@/modules/product/types';
import { type PresApiSearchProduct } from '@/modules/search/aliases';

export type SearchListProductProps = {
  slug: PresApiSearchProduct['slug'];
  preview?: Preview;
  pricing: PresApiSearchProduct['pricing'];
  sizes?: PresApiSearchProduct['sizes'];
  pictures?: PresApiSearchProduct['pictures'];
  isBoosted?: PresApiSearchProduct['is_boosted'];
  brandName?: PresApiSearchProduct['brand_name'];
  id: PresApiSearchProduct['id'];
  isLiked?: PresApiSearchProduct['is_liked'];
};

export function isSearchListProductProps(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  arg: any
): arg is SearchListProductProps {
  return (
    arg &&
    typeof arg.id === 'number' &&
    typeof arg.slug === 'string' &&
    (arg.isLiked === undefined || typeof arg.isLiked === 'boolean') &&
    typeof arg.pricing.final_price_key === 'string'
  );
}

export function getSearchListProductPropsDebugInfo<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends React.ComponentType<any>,
>(arg: React.ComponentProps<T>) {
  return {
    id: arg.id,
    slug: arg.slug,
    isLiked: arg.isLiked,
    preview: arg.preview,
    finalPriceKey: arg.pricing?.final_price_key,
  };
}
